export default __webpack_public_path__ + "static/miraes-quick-aac90ff8ade01d9a3f0e2862163efa0a.jpg";